import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";

export const DirectorsNote = ({ dark = true }) => {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await api.post("/directors-note", { email });
      setDone(true);
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const ink = dark ? "text-ivory" : "text-charcoal";
  const sub = dark ? "text-ivory/60" : "text-charcoal/60";

  return (
    <div data-testid="directors-note-block">
      <p className={`text-xs font-semibold tracking-[0.28em] uppercase ${dark ? "text-goldlight" : "text-gold"}`}>Director’s Note</p>
      <h3 className={`mt-3 font-serif text-2xl lg:text-3xl font-medium leading-snug ${ink}`}>
        One sharp property observation, delivered when there is something worth saying.
      </h3>
      <p className={`mt-3 text-sm leading-relaxed ${sub}`}>
        Concise thinking on buyer behaviour, market signals, risk and better property decisions —
        written by Matthew Clark.
      </p>
      {done ? (
        // Deliberately generic: the backend never reveals whether an address was
        // already subscribed or previously unsubscribed (anti-enumeration + no
        // silent reactivation). Do not "improve" this into a state-revealing message.
        <p className="mt-6 text-sm text-gold" data-testid="directors-note-success">
          Thank you — your subscription is recorded.
        </p>
      ) : (
        <form onSubmit={submit} className="mt-6 flex flex-col xl:flex-row gap-3" data-testid="directors-note-form">
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email address"
            data-testid="directors-note-email"
            className={`flex-1 min-w-0 bg-transparent border px-4 py-3.5 text-sm outline-none transition-colors duration-300 ${
              dark
                ? "border-white/25 text-ivory placeholder:text-ivory/40 focus:border-gold"
                : "border-charcoal/25 text-charcoal placeholder:text-charcoal/40 focus:border-gold"
            }`}
          />
          <button
            type="submit"
            disabled={loading}
            data-testid="directors-note-submit"
            className="shrink-0 px-6 py-3.5 bg-gold text-ink text-xs font-semibold tracking-[0.18em] uppercase whitespace-nowrap transition-[background-color] duration-300 hover:bg-ivory disabled:opacity-60"
          >
            {loading ? "Sending…" : "Send me the Director’s Note"}
          </button>
        </form>
      )}
      <p className={`mt-4 text-xs ${sub}`}>
        No market noise. No property hype.{" "}
        <Link to="/unsubscribe" data-testid="directors-note-unsubscribe-link" className={`underline underline-offset-4 transition-colors duration-300 ${dark ? "hover:text-goldlight" : "hover:text-golddark"}`}>
          Unsubscribe anytime
        </Link>
        .
      </p>
    </div>
  );
};
